<template>
  <v-textarea
    v-model="input"
    :dense="dense"
    v-bind="$attrs"
    rows="3"
    outlined
    :rules="getRules"
    @input="$emit('input', input)"
  />
</template>

<script>
import { getRules } from "../../../assets/js/common";
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: "",
    },
    customRules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      input: "",
    };
  },
  computed: {
    getRules() {
      let { customRules, rules } = this;
      if (customRules.length > 0) return customRules;
      return getRules(rules);
    },
  },
  watch: {
    value(val) {
      this.input = val;
    },
  },
  mounted() {
    this.input = this.value;
  },
};
</script>
